import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective } from '@maskito/angular';

import { ErrorMessageDirective } from '../../directives/error-message.directive';
import { RequiredDirective } from '../../directives/required.directive';
import { MiscModule } from '../../misc.module';
import { AffordabilityPageRoutingModule } from './affordability-routing.module';
import { AffordabilityPageComponent } from './affordability.page';
import { ReportModalComponent } from './report-modal/report-modal.component';

@NgModule({
  declarations: [AffordabilityPageComponent, ReportModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    AffordabilityPageRoutingModule,
    MiscModule,
    MaskitoDirective,
    ErrorMessageDirective,
    RequiredDirective
  ]
})
export class AffordabilityPageModule {}
